export default "__VITE_ASSET__1bb10d7b__"